import React from "react";
import Login from "./Login";

export default function Authentiocation() {
  return (
    <div className="min-h-screen flex justify-center items-center">
      <div className="px-0 sm:px-8 w-full lg:w-1/2 xl:w-1/3 flex justify-center">
        <div className="flex justify-center bg-white shadow-light-lg py-12 px-6 sm:px-12 rounded-md max-w-sm w-full">
          <Login />
        </div>
      </div>
    </div>
  );
}
